import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from '@atlaskit/page-header';
import { Grid, GridColumn } from '@atlaskit/page';

import Layout from '../../templates/Layout';
import {
  QueryBuilder, SchemaGenerator, Console, Messages,
} from './components';

class Development extends React.Component {
  getPluginByParameter() {
    const { plugin } = this.props.match.params;

    if (plugin === 'query-builder') {
      return <QueryBuilder />;
    } if (plugin === 'schema-generator') {
      return <SchemaGenerator />;
    } if (plugin === 'console') {
      return <Console />;
    } if (plugin === 'messages') {
      return <Messages />;
    }

    return <p>I think you wrote a plugin name that does not exist.</p>;
  }

  render() {
    return (
      <Layout>
        <Grid>
          <GridColumn medium={12}>
            <PageHeader>Development</PageHeader>
            {this.getPluginByParameter()}
          </GridColumn>
        </Grid>
      </Layout>
    );
  }
}

Development.propTypes = {
  match: PropTypes.shape(),
};

Development.defaultProps = {
  match: {},
};

export default Development;
